import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-audio-skip-forward-button',
  templateUrl: './audio-skip-forward-button.component.html'
})
export class AudioSkipForwardButtonComponent implements OnInit {
  faRedoAlt = faRedoAlt

  @Input()
  disabled!: boolean

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) { }

  ngOnInit(): void {
  }

  skipForwards() {    
    // use effects to detect this, get current time, add 10 seconds and resubmit event
    this.store.dispatch(new actions.SkipForward());
  }
}
